import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { colors } from '_styles';
import { _ } from '_locales';
import HOC from '_HOC';

import * as actions from '../../redux/actions';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Title = styled.h3`
    font-size: 20px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    color: #000;
    text-align: left;
`;

const NextButton = styled.button`
    position: relative;
    font-size: 14px;
    padding: 20px 0;
    background-color: ${colors.RC_ACTION};
    cursor: pointer;
    border: none;
    border-radius: 8px;
    color: #fff;
    width: 160px;
    height: 39px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px auto 15px;
`;

const ReportButton = styled.button`
    border: none;
    margin: 0 auto;
    display: block;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer !important;
    color: ${colors.RC_ACTION};
    background-color: transparent;
`;

const MissedCollectionSubmission = ({ setFromHelp, props }) => {
  const { location, history } = props;
  const { title: collectionName } = location.state;

  return (
    <Container>
      <Title>{_('help.was_a_sticker_placed_on_the_materials_left_behind')}</Title>

      <NextButton onClick={() => history.push('/help/missed-collection-submission/review-sticker')}>{_('help.next')}</NextButton>
      <ReportButton
        onClick={() => [setFromHelp(true), history.push('/help/form-page', {
          title: _('help.report_missed_pickup'),
          type: 'MISSED_PICKUP',
          description: `Collection Name: ${collectionName}`
        })]}
      >
        {_('help.there_was_no_sticker')}
      </ReportButton>
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setFromHelp: (fromHelp) => dispatch(actions.setFromHelp(fromHelp)),
});

export default HOC(connect(null, mapDispatchToProps)(MissedCollectionSubmission));
